import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const departmentPerformanceService = {
  

  getDepartmentList: async () => {
    try {
      const response = await axiosInstance.get(API.department.getList);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDepartmentPerformance: async(departmentId, periodType = null, referenceDate = null) => {
    try{
        const response = await axiosInstance.get(
          API.reports.getDepartmentPerfomance(departmentId, periodType, referenceDate)
        );
        // Point 13: response is now { period, data }. Return the analytics plus
        // the resolved period label (fallback to raw body if not switched yet).
        const body = response.data;
        return {
          data: body && body.data !== undefined ? body.data : body,
          periodLabel: body?.period?.periodLabel || "",
        };
    } catch (error){
        throw error;
    }
  }
};
